import cx from 'classnames';
import "./ModalHeader.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ModalHeader(_ref) {
  let {
    children,
    className,
    image,
    primaryTitle,
    secondaryTitle,
    tag: Tag = 'div',
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs(Tag, {
    className: cx('ModalHeader', className),
    ...rest,
    "data-sentry-element": "Tag",
    "data-sentry-component": "ModalHeader",
    "data-sentry-source-file": "ModalHeader.tsx",
    children: [image && /*#__PURE__*/_jsx("div", {
      className: "ModalHeader__image",
      children: image
    }), (primaryTitle || secondaryTitle) && /*#__PURE__*/_jsxs("div", {
      className: "ModalHeader__main",
      children: [primaryTitle && /*#__PURE__*/_jsx("h2", {
        className: "ModalHeader__primary-title",
        children: primaryTitle
      }), secondaryTitle && /*#__PURE__*/_jsx("h3", {
        className: "ModalHeader__secondary-title",
        children: secondaryTitle
      })]
    }), children && /*#__PURE__*/_jsx("div", {
      className: "ModalHeader__body",
      children: children
    })]
  });
}